<template>
  <v-card id="account-setting-card">
    <!-- {{ user }} -->
    <!-- tabs -->
    <v-tabs v-model="tab" show-arrows>
      <v-tab v-for="tab in tabs" :key="tab.icon">
        <v-icon size="20" class="me-3">
          {{ tab.icon }}
        </v-icon>
        <span>{{ tab.title }}</span>
      </v-tab>
    </v-tabs>

    <!-- tabs item -->
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div v-if="user.role == 'Peserta Didik' || user.role == 'PESERTA DIDIK'">
          <register-peserta-dokter v-if="user.profesi == 'Dokter'"></register-peserta-dokter>
          <register-peserta-pPDS v-if="user.profesi == 'PPDS'"></register-peserta-pPDS>
          <register-peserta-keperawatanDll
            v-if="user.profesi == 'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain'"
          ></register-peserta-keperawatanDll>
        </div>
        <div v-else-if="user.role == 'PEMBIMBING KLINIK'">
          <register-pembimbing></register-pembimbing>
        </div>
        <div v-else-if="user.role == 'UNIVERSITAS'">
          <register-universitas></register-universitas>
        </div>
        <div v-else-if="user.role == 'REGISTERED'">
          <v-alert type="warning"
            >Registrasi anda belum selesai &nbsp;
            <router-link :to="{ name: 'RegisterLanjutan' }" title="Lanjut registrasi">
              <v-btn small color="primary"> Registrasi Lanjutan </v-btn>
            </router-link></v-alert
          >
        </div>
      </v-tab-item>
      <v-tab-item>
        <account-settings-security></account-settings-security>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mdiAccountOutline, mdiLockOpenOutline, mdiInformationOutline, mdiAccount } from '@mdi/js'
import { ref } from '@vue/composition-api'

// demos
import AccountSettingsAccount from './AccountSettingsAccount.vue'
import AccountSettingsSecurity from './AccountSettingsSecurity.vue'
import AccountSettingsInfo from './AccountSettingsInfo.vue'

import RegisterPesertaDokter from './RegisterPeserta/RegisterPesertaDokter.vue'
import RegisterPesertaPPDS from './RegisterPeserta/RegisterPesertaPPDS.vue'
import RegisterPesertaKeperawatanDll from './RegisterPeserta/RegisterPesertaKeperawatanDll.vue'
import RegisterPembimbing from './RegisterPembimbing/RegisterPembimbing.vue'
import RegisterUniversitas from './RegisterUniversitas.vue'

export default {
  components: {
    AccountSettingsAccount,
    AccountSettingsSecurity,
    AccountSettingsInfo,

    RegisterPesertaDokter,
    RegisterPesertaPPDS,
    RegisterPesertaKeperawatanDll,
    RegisterPembimbing,
    RegisterUniversitas,
  },
  setup() {
    const tab = ref('')

    // tabs
    const tabs = [
      // { title: 'Akun', icon: mdiAccountOutline },
      { title: 'Detail Akun', icon: mdiAccount },
      { title: 'Keamanan', icon: mdiLockOpenOutline },
    ]

    return {
      tab,
      tabs,
      icons: {
        mdiAccountOutline,
        mdiLockOpenOutline,
        mdiInformationOutline,
        mdiAccount,
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
  },
}
</script>
